import { isV2Enabled } from './isV2Enabled';

export const isV2ProviderLocationsEnabled = () =>
  isV2Enabled('REACT_APP_FEATURE_TOGGLE_NEW_PROVIDER_LOCATIONS_PAGE_ENABLED');
